<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-lg-6">
            <div [innerHtml]="applicationHtml"></div>
        </div>
    </div>
</div>
  <app-aaos-spinner [isLoading]="loading"></app-aaos-spinner>
